<div class="modal fade" id="rename-modal" aria-labelledby="rename-modal" role="dialog" tabindex="-1"
  [ngStyle]="{'display': showRenameModal ? 'block' : 'none', 'opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content h-90">
      @if (!universalService?.isMobileDevice) {
        <div class="modal-header">
          <button type="button" class="close btn-pos" data-dismiss="modal" (click)="closePopUp()" aria-hidden="false">
            <span class="NeueFile_Cancel"></span>
            <span class="esc">esc</span>
          </button>
          <h5>Rename</h5>
        </div>
      }

      @if (universalService?.isMobileDevice) {
        <div class="mobheader border-bottom-0" >
          <span class="NeueFile_Cancel mt-3 mr-3" (click)="closePopUp()"></span>
        </div>
      }

      <div class="modal-body border-bottom-0">

        <div class="renameContent mt-3">
          <input aria-hidden="false" aria-label="fileName" #newName id="rename_input_box" maxlength="200" class="inputBox" type="text" value="{{fileName}}" (keyup)="newNameValidation(newName)" autofocus [ngClass]="[ universalService?.selectedFile?.objectType == 'FR' ? 'folderNameLabel' : '']">
          <input aria-hidden="false" aria-label="extensionLabel" #fileExtn title="{{universalService?.selectedFile?.extension}}" class="extensionLabel" [ngClass]="[ universalService?.selectedFile?.objectType == 'FR' ? 'folderExtensionLabel' : '']" type="text" value="{{universalService?.selectedFile?.extension}}" readonly >
          <div class="inputError">
            @if (renameError != '') {
              <span><i class="NeueAlert mr-1"></i>{{renameError}}</span>
            }
          </div>
        </div>

      </div>
      <div class="modal-footer border-top-0 p-3">
        <div class="rename-btn-main">
          <button [disabled]="!enableButton" class="pointer" (click)="renameObject()">SAVE</button>
        </div>
      </div>
    </div>
  </div>
</div>
